import styled from 'styled-components';

export const Container = styled.span`
  cursor: pointer;
  html[dir='rtl'] & {
    transform: scale(${({ direction }) => (direction === 'back' ? '1, 1 ' : '-1, 1')});
  }
`;
